import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import DatasetIcon from '@mui/icons-material/Dataset';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import HomeIcon from '@mui/icons-material/Home';
import {config} from "./config";
import CSVFile from "./components/csvfile";
import TagStack from "./components/tags";
import Footer from "./components/footer";
import {HashLoader} from "react-spinners";
import Button from "@mui/material/Button";


function DatasetPage() {
    const {dataset_name} = useParams();
    const [dataset, setDataset] = useState(null);
    const [loading, setLoading] = useState(true);
    const API_URL = config.api_url;


    useEffect(() => {
        const requestOptions = {
            method: 'GET',
            mode: 'cors',
            headers: {'Content-Type': 'application/json'},
        };

        async function fetchData() {
            try {
                fetch(API_URL + '/dataset/' + dataset_name, requestOptions)
                    .then((res) => {
                        if (res.ok) {
                            return res.json()
                        } else {
                            return Promise.reject('error');
                        }
                    })
                    .then((data) => setDataset(data))
                    .catch(error => console.log('error is', error))
                    .finally(() => setLoading(false));
            } catch (error) {
                console.error('Error fetching datasets:', error);
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    if (loading) {
        // return <div>Loading...</div>;
        return <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}><HashLoader
            loading={loading}
            size={100}
            aria-label="Loading Spinner"
            data-testid="loader"
            color={"#36d7b7"}
        /></div>
    }

    if (dataset) {
        return (
            <div style={{marginLeft: "5%", marginRight: "5%", marginTop: "3%"}}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href={`${config.web_prefix}/`}>
                        <HomeIcon fontSize="small"/> Home
                    </Link>
                    <Typography color="text.primary">Dataset Detail</Typography>
                </Breadcrumbs>
                <h1>
                    <DatasetIcon fontSize={"Large"}/>{dataset.title}
                    <Button variant="outlined" sx={{marginLeft: '10px'}} onClick={() => {
                        navigator.clipboard.writeText(dataset_name)
                    }}>Copy ID</Button>
                </h1>
                <Typography variant="body1" component="div">
                    <strong>Uploader:</strong> <br/> {dataset.organization.title}
                </Typography>
                <br/>
                <Typography variant="body1" component="div">
                    <strong>Description:</strong><br/>{dataset.notes}
                </Typography>
                <br/>

                <TagStack tags={dataset.tags}/>

                {dataset.csvfiles.length > 0 ? <div>
                    <h2>CSV Files</h2>
                    <Box sx={{width: '100%'}}>
                        <Stack spacing={5} alignItems={"left"} marginLeft={"2%"}>
                            {dataset.csvfiles.map((csvFile) => (
                                <CSVFile data={csvFile} key={`id-csvfile-${csvFile._id}`}/>))}
                        </Stack>
                    </Box>
                </div> : ""}
                <Footer/>
            </div>
        );
    } else {
        return (
            <div style={{marginLeft: "5%", marginRight: "5%", marginTop: "3%"}}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/">
                        <HomeIcon fontSize="small"/> Home
                    </Link>
                    <Typography color="text.primary">Dataset Detail</Typography>
                </Breadcrumbs>
                <br/>
                <Typography variant="body1" component="div">
                    Dataset Not Found: {dataset_name} <br/><br/>
                    Please make sure that you have the right URL.
                </Typography>
                <Footer/>
            </div>);
    }
}

export default DatasetPage;